export const DESKTOP_CONTENT_WIDTH = 626;

export const BRANCH_APP_LINK = 'https://concreit.app.link/dU4gxootNrb';

export const APP_CONTENT_BLOCKS = [
  'assetHighlights',
  'header',
  'mapInformation',
  'description',
  'assetFeatures',
  'topEmployers',
  'images',
  'primaryPartner',
  'assetDetails',
  'locationInfo',
  'loanDetails',
  'capitalStack',
  'investmentOverview',
  'risksAndMitigants',
  'businessPlan',
  'propertyValuation',
  'timeLine',
];

export enum APP_CONTEXT {
  APP = 'app',
  WEB = 'web',
}

export enum RESPONSIVE_MODE {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
